<h1 mat-dialog-title class="title">Form Submitted Successfully</h1>
<div mat-dialog-content class="image-text">
  <img
    src="../../../../assets/weDraw-Images/undraw_certification_re_ifll (1).svg"
    alt="orange shirt woman with check box"
    width="200"
    height="200"
  />
  <p>Keep an eye on your email for communication from our support team.</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">OK</button>
</div>
